export function getRegisters(
    startAddress = 5250,
): Readonly<Readonly<[key: string, addr: string, updatePerSec: number]>[]> {
    const result: Readonly<[key: string, addr: string, updatePerSec: number]>[] = [];
    for (let i = 0; i < 35; i++) {
        result.push([`periodStart${i + 1}`, `${startAddress + i * 2}`, 60 * 60]);
        result.push([`periodEnd${i + 1}`, `${startAddress + i * 2 + 1}`, 60 * 60]);
    }
    return result;
}

export interface Event {
    startMin: number;
    endMin: number;
    day: number;
    storeKeys: [start: string, end: string];
}

export function getEvents(data: Record<string, string | undefined>): Event[] {
    const result: Event[] = [];

    for (let i = 0; i < 35; i++) {
        const startValueWeekMin = Number(data[`periodStart${i + 1}`]);
        const endValueWeekMin = Number(data[`periodEnd${i + 1}`]);
        if (
            isNaN(startValueWeekMin) ||
            isNaN(endValueWeekMin) ||
            !startValueWeekMin ||
            !endValueWeekMin ||
            startValueWeekMin > endValueWeekMin
        ) {
            continue;
        }

        const dayStart = Math.floor((startValueWeekMin - 1) / 1440);

        result.push({
            startMin: startValueWeekMin - 1 - dayStart * 1440,
            endMin: endValueWeekMin - dayStart * 1440,
            day: dayStart,
            storeKeys: [`periodStart${i + 1}`, `periodEnd${i + 1}`],
        });
    }

    return result;
}
